import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-ayuda-modal',
  templateUrl: './ayuda-modal.component.html',
  styleUrls: ['./ayuda-modal.component.css']
})
export class AyudaModalComponent implements OnInit {

  ayuda: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    console.log("Cargando modal detalle ayuda:");
    console.log(this.data);
    this.ayuda = this.data;
  }

}
